import { render, staticRenderFns } from "./BlogCommentEdit.vue?vue&type=template&id=3d686b0d&scoped=true&"
import script from "./BlogCommentEdit.vue?vue&type=script&lang=js&"
export * from "./BlogCommentEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d686b0d",
  null
  
)

export default component.exports